export default __webpack_public_path__ + "static/media/logo_dl_white.500a56cf.svg";